import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../_actions';

class AboutPage extends React.Component {

    handleDeleteUser(_id) {
        return (e) => this.props.dispatch(userActions.delete(_id));
    }

    render() {
        return (
          <div className='col-md-6 col-md-offset-3'>
            <h3>About Fix-A-Drink</h3>

            <p>
              Fix-A-Drink is a cocktail recipe search engine that lets you
              search by liquors you have stocked in your bar. Find hundreds of
              cocktail recipes you can make right now with the ingredients you
              have available in your bar and fridge. Fix-a-Drink can help you
              save hundreds on liquor store purchases by showing you how to
              fully use the ingredients you already have. No more dusty old
              liquor bottles! The categories of cocktails you can find on
              Fix-a-Drink include Sweet, Strong, Creamy, Frozen, and Bitter.
            </p>
            <div>
              Just the facts
              <ul>
                <li>
                  It was developed by{' '}
                  <a href='https://www.stevebreese.com'>Steve Breese</a> in
                  March of 2020.
                </li>
                <li>It was built with React vs. 16. & Nest.js vs. 10</li>
              </ul>
              Why Fix-A-Drink is better than similar websites
              <ul>
                <li>Higher performance app - get your drink recipes fast</li>
                <li>
                  Vetted cocktails - you're sure to make a great cocktail every
                  time
                </li>
                <li>
                  Easy searching - find the exact cocktail you are currently in
                  the mood for
                </li>
                <li>
                  Great user experience - get your ingredients entered in no
                  time
                </li>
                <li>and best of all... NO ADVERTISEMENTS!!!</li>
              </ul>
              Why you should create a user account
              <ul>
                <li>Access your ingredients and recipes between devices</li>
                <li>
                  Avoid losing your ingredients and recipes upon clearing your
                  local browser data
                </li>
                <li>and still... NO ADVERTISEMENTS!!!</li>
              </ul>
              Technologies you are experiencing
              <ul>
                <li>React JavaScript library for user interface</li>
                <li>Redux JavaScript library for managing application state</li>
                <li>Node/NextJS backend (server for API, proxy, & routing)</li>
                <li>JSX syntactic sugar for templating</li>
                <li>MongoDB document-oriented database</li>
                <li>Bootstrap mobile-first front-end framework</li>
                <li>Mongoose object document mapper</li>
                <li>Passport authentication middleware</li>
                <li>Heroku cloud platform as a service</li>
                <li>
                  Dozens of React components I've{' '}
                  <a href='https://js.coach/?collection=React'>found</a>
                </li>
                <li>Node.js backend (server for API, proxy, & routing)</li>
              </ul>
              Development technologies
              <ul>
                <li>Visual Studio Code integrated development environment</li>
                <li>Git distributed version control system</li>
                <li>Dropbox for cloud storage</li>
              </ul>
            </div>
          </div>
        )
    }
}

function mapStateToProps(state) {
}

const connectedAboutPage = connect(mapStateToProps)(AboutPage);
export { connectedAboutPage as AboutPage };


// WEBPACK FOOTER //
// ./src/AboutPage/AboutPage.jsx